// import React, { useState } from 'react';
// import { NavLink, useLocation, useNavigate } from 'react-router-dom';

// const AdminMenuPanel = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   // Funkcja do renderowania odpowiedniego komponentu na podstawie ścieżki
//   const renderContent = () => {
//     switch(location.pathname) {
//       case '/admin/AdminAboutPanel':
//         return <div className="panel-content">Panel O Nas</div>;
//       case '/admin/AdminHeroPanel':
//         return <div className="panel-content">Panel Sekcji Głównej</div>;
//       case '/admin/AdminOfferPanel':
//         return <div className="panel-content">Panel Oferty</div>;
//       case '/admin/AdminPricingPanel':
//         return <div className="panel-content">Panel Cennika</div>;
//       case '/admin/AdminAttractionsPanel':
//         return <div className="panel-content">Panel Atrakcji</div>;
//       case '/admin/AdminContactPanel':
//         return <div className="panel-content">Panel Kontaktu</div>;
//       default:
//         return (
//           <div className="panel-content">
//             <h2>Panel Administracyjny</h2>
//             <p>Wybierz sekcję do edycji z menu po lewej stronie.</p>
//           </div>
//         );
//     }
//   };

//   return (
//     <div className="admin-panel">
//       {/* Górny pasek nawigacyjny */}
//       <header className="admin-header">
//         <button className="menu-toggle" onClick={toggleMenu}>
//           ☰
//         </button>
//         <h1>Panel Administracyjny</h1>
//         <div className="user-info">Administrator</div>
//       </header>

//       <div className="admin-container">
//         {/* Boczny pasek nawigacyjny */}
//         <aside className={`admin-sidebar ${isMenuOpen ? 'open' : ''}`}>
//           <nav>
//             <ul className="admin-menu">
//               <li>
//                 <NavLink 
//                   to="/admin/AdminAboutPanel" 
//                   className={({ isActive }) => isActive ? 'active' : ''}
//                   onClick={() => setIsMenuOpen(false)}
//                 >
//                   O Nas
//                 </NavLink>
//               </li>
//               <li>
//                 <NavLink 
//                   to="/admin/AdminHeroPanel" 
//                   className={({ isActive }) => isActive ? 'active' : ''}
//                   onClick={() => setIsMenuOpen(false)}
//                 >
//                   Sekcja Główna
//                 </NavLink>
//               </li>
//               <li>
//                 <NavLink 
//                   to="/admin/AdminOfferPanel" 
//                   className={({ isActive }) => isActive ? 'active' : ''}
//                   onClick={() => setIsMenuOpen(false)}
//                 >
//                   Oferta
//                 </NavLink>
//               </li>
//               <li>
//                 <NavLink 
//                   to="/admin/AdminPricingPanel" 
//                   className={({ isActive }) => isActive ? 'active' : ''}
//                   onClick={() => setIsMenuOpen(false)}
//                 >
//                   Cennik
//                 </NavLink>
//               </li>
//               <li>
//                 <NavLink 
//                   to="/admin/AdminAttractionsPanel" 
//                   className={({ isActive }) => isActive ? 'active' : ''}
//                   onClick={() => setIsMenuOpen(false)}
//                 >
//                   Atrakcje
//                 </NavLink>
//               </li>
//               <li>
//                 <NavLink 
//                   to="/admin/AdminContactPanel" 
//                   className={({ isActive }) => isActive ? 'active' : ''}
//                   onClick={() => setIsMenuOpen(false)}
//                 >
//                   Kontakt
//                 </NavLink>
//               </li>
//             </ul>
//           </nav>
//         </aside>

//         {/* Główna zawartość */}
//         <main className="admin-main">
//           {renderContent()}
//         </main>
//       </div>
//     </div>
//   );
// };

// // Style CSS
// const styles = `
// .admin-panel {
//   min-height: 100vh;
//   background-color: #f5f5f5;
// }

// .admin-header {
//   display: flex;
//   align-items: center;
//   padding: 0 20px;
//   height: 60px;
//   background-color: #2c3e50;
//   color: white;
//   box-shadow: 0 2px 5px rgba(0,0,0,0.1);
// }

// .menu-toggle {
//   display: none;
//   background: none;
//   border: none;
//   color: white;
//   font-size: 1.5rem;
//   cursor: pointer;
//   margin-right: 15px;
// }

// .admin-header h1 {
//   font-size: 1.5rem;
//   margin: 0;
//   flex-grow: 1;
// }

// .user-info {
//   padding: 5px 15px;
//   background-color: #34495e;
//   border-radius: 20px;
//   font-size: 0.9rem;
// }

// .admin-container {
//   display: flex;
//   min-height: calc(100vh - 60px);
// }

// .admin-sidebar {
//   width: 250px;
//   background-color: #34495e;
//   color: white;
//   transition: transform 0.3s ease;
// }

// .admin-menu {
//   list-style: none;
//   padding: 0;
//   margin: 20px 0;
// }

// .admin-menu li {
//   margin-bottom: 5px;
// }

// .admin-menu a {
//   display: block;
//   padding: 12px 20px;
//   color: #ecf0f1;
//   text-decoration: none;
//   transition: background-color 0.3s;
// }

// .admin-menu a:hover {
//   background-color: #3c546f;
// }

// .admin-menu a.active {
//   background-color: #3498db;
//   font-weight: bold;
// }

// .admin-main {
//   flex-grow: 1;
//   padding: 20px;
//   background-color: white;
//   margin: 20px;
//   border-radius: 5px;
//   box-shadow: 0 2px 10px rgba(0,0,0,0.05);
// }

// .panel-content {
//   padding: 20px;
//   font-size: 1.2rem;
//   color: #555;
// }

// .panel-content h2 {
//   color: #2c3e50;
//   margin-bottom: 15px;
// }

// @media (max-width: 768px) {
//   .menu-toggle {
//     display: block;
//   }
  
//   .admin-sidebar {
//     position: fixed;
//     top: 60px;
//     left: 0;
//     height: calc(100vh - 60px);
//     z-index: 1000;
//     transform: translateX(-100%);
//   }
  
//   .admin-sidebar.open {
//     transform: translateX(0);
//   }
  
//   .admin-main {
//     margin: 10px;
//     padding: 15px;
//   }
// }
// `;

// // Komponent do wstrzyknięcia stylów
// const StyleInjector = () => <style>{styles}</style>;

// // Główny komponent eksportujący panel administracyjny
// const AdminMenuPanelWithStyles = () => (
//   <>
//     <StyleInjector />
//     <AdminMenuPanel />
//   </>
// );

// export default AdminMenuPanelWithStyles;

import React, { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';

const AdminMenuPanel = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Funkcja do renderowania odpowiedniego komponentu na podstawie ścieżki
  const renderContent = () => {
    switch(location.pathname) {
      case '/admin/AdminAboutPanel':
        return <div className="p-6 bg-white rounded-xl shadow-lg">Panel O Nas</div>;
      case '/admin/AdminHeroPanel':
        return <div className="p-6 bg-white rounded-xl shadow-lg">Panel Sekcji Głównej</div>;
      case '/admin/AdminOfferPanel':
        return <div className="p-6 bg-white rounded-xl shadow-lg">Panel Oferty</div>;
      case '/admin/AdminPricingPanel':
        return <div className="p-6 bg-white rounded-xl shadow-lg">Panel Cennika</div>;
      case '/admin/AdminAttractionsPanel':
        return <div className="p-6 bg-white rounded-xl shadow-lg">Panel Atrakcji</div>;
      case '/admin/AdminContactPanel':
        return <div className="p-6 bg-white rounded-xl shadow-lg">Panel Kontaktu</div>;
      default:
        return (
          <div className="p-6 bg-white rounded-xl shadow-lg">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Panel Administracyjny</h2>
            <p className="text-gray-600">Wybierz sekcję do edycji z menu po lewej stronie.</p>
          </div>
        );
    }
  };

  return (
    <div className="min-h-screen bg-[#edece8]">
      {/* Górny pasek nawigacyjny */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 flex items-center h-16">
          <button className="menu-toggle md:hidden mr-4 text-gray-700" onClick={toggleMenu}>
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <h1 className="text-xl font-bold text-gray-800">Panel Administracyjny</h1>
          <div className="ml-auto bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-medium">
            Administrator
          </div>
        </div>
      </header>

      <div className="flex flex-col md:flex-row max-w-7xl mx-auto px-4 py-6">
        {/* Boczny pasek nawigacyjny */}
        <aside className={`bg-white rounded-xl shadow-lg p-4 mb-6 md:mb-0 md:mr-6 md:w-64 ${isMenuOpen ? 'block' : 'hidden md:block'}`}>
          <nav>
            <ul className="space-y-2">
              <li>
                <NavLink 
                  to="/admin/AdminAboutPanel" 
                  className={({ isActive }) => 
                    `flex items-center px-4 py-3 rounded-lg transition-colors duration-300 ${
                      isActive 
                        ? 'bg-yellow-500 text-white font-semibold' 
                        : 'text-gray-700 hover:bg-yellow-100 hover:text-yellow-700'
                    }`
                  }
                  onClick={() => setIsMenuOpen(false)}
                >
                  O Nas
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/AdminHeroPanel" 
                  className={({ isActive }) => 
                    `flex items-center px-4 py-3 rounded-lg transition-colors duration-300 ${
                      isActive 
                        ? 'bg-yellow-500 text-white font-semibold' 
                        : 'text-gray-700 hover:bg-yellow-100 hover:text-yellow-700'
                    }`
                  }
                  onClick={() => setIsMenuOpen(false)}
                >
                  Sekcja Główna
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/AdminOfferPanel" 
                  className={({ isActive }) => 
                    `flex items-center px-4 py-3 rounded-lg transition-colors duration-300 ${
                      isActive 
                        ? 'bg-yellow-500 text-white font-semibold' 
                        : 'text-gray-700 hover:bg-yellow-100 hover:text-yellow-700'
                    }`
                  }
                  onClick={() => setIsMenuOpen(false)}
                >
                  Oferta
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/AdminPricingPanel" 
                  className={({ isActive }) => 
                    `flex items-center px-4 py-3 rounded-lg transition-colors duration-300 ${
                      isActive 
                        ? 'bg-yellow-500 text-white font-semibold' 
                        : 'text-gray-700 hover:bg-yellow-100 hover:text-yellow-700'
                    }`
                  }
                  onClick={() => setIsMenuOpen(false)}
                >
                  Cennik
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/AdminAttractionsPanel" 
                  className={({ isActive }) => 
                    `flex items-center px-4 py-3 rounded-lg transition-colors duration-300 ${
                      isActive 
                        ? 'bg-yellow-500 text-white font-semibold' 
                        : 'text-gray-700 hover:bg-yellow-100 hover:text-yellow-700'
                    }`
                  }
                  onClick={() => setIsMenuOpen(false)}
                >
                  Atrakcje
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/AdminContactPanel" 
                  className={({ isActive }) => 
                    `flex items-center px-4 py-3 rounded-lg transition-colors duration-300 ${
                      isActive 
                        ? 'bg-yellow-500 text-white font-semibold' 
                        : 'text-gray-700 hover:bg-yellow-100 hover:text-yellow-700'
                    }`
                  }
                  onClick={() => setIsMenuOpen(false)}
                >
                  Kontakt
                </NavLink>
              </li>
            </ul>
          </nav>
        </aside>

        {/* Główna zawartość */}
        <main className="flex-1">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default AdminMenuPanel;